import { useCallback, useContext } from 'react';
import { toast } from 'react-toastify';
import { ChatbotContext } from 'providers/ChatbotProvider';
import useFetch from 'use-http';

const useBotSession = () => {
    const { setNewBotSessionLoading } = useContext(ChatbotContext);
    const { post } = useFetch();

    // TODO: Create a custom hook to get url param value
    var botId = '733f2098-1964-40e6-a956-285898ba7ff7'; //'733f2098-1964-40e6-a956-285898ba7ff7';

    const createNewBotSession = useCallback(async () => {
        setNewBotSessionLoading(true);
        const url = `/create_session_anonymous`;

        try {
            const response = await post(url, { botId });
            console.log({ createNewBotSessionResponse: response });

            const isSuccess = response?.sessionId;

            if (!isSuccess) toast.error(response?.message);

            return { isSuccess, botSessionId: response?.sessionId };
        } catch (err) {
            console.error(err);
            toast.error('Something went wrong, please try again later');
            throw err;
        } finally {
            setNewBotSessionLoading(false);
        }
    }, [botId, post, setNewBotSessionLoading]);

    return { createNewBotSession };
};

export default useBotSession;
